<template>
    <div :class="['page-view', 'story-view', {loaded: !loading}]">
        <Breadcrumb/>
        <transition name="fade" mode="out-in">
            <div v-if="!loading">
                <Textblock :layout="{
                    columns: true,
                    baseline: `<h2>${page.name}</h2>`,
                    description: `<p>${page.baseline}</p>`,
                }"/>
                <StoryHeading :layout="page"/>
                <component
                    :key="layout.id"
                    v-for="layout in page.layout"
                    :is="layout.acf_fc_layout"
                    :layout="layout"
                />
            </div>
        </transition>
        <MainFooter
            v-if="page"
        />
    </div>
</template>

<script>
import PageView from '@/components/MixinPageView'
import StoryHeading from '@/views/Story/StoryHeading'
export default {
    name: 'story',
    components: {
        StoryHeading
    },
    mixins: [PageView],
    watch: {
        '$route.params.locale'() {
            this.requestData({taxonomy: true})
                .then(() => {
                    window.scroll(0, 0)
                })
        },
        '$route'() {
            this.requestData({taxonomy: true})
                .then(() => {
                    window.scroll(0, 0)
                })
        }
    },
    created()
    {
        this.requestData({taxonomy: true})
            .then(() => {
                window.scroll(0, 0)
            })
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
</style>
